import { render, staticRenderFns } from "./publishTask.vue?vue&type=template&id=6b16a8e5&scoped=true&"
import script from "./publishTask.vue?vue&type=script&lang=js&"
export * from "./publishTask.vue?vue&type=script&lang=js&"
import style0 from "./publishTask.vue?vue&type=style&index=0&id=6b16a8e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16a8e5",
  null
  
)

export default component.exports